import React, { useRef, useEffect } from 'react';
import styled from 'styled-components/macro';
import Header from './components/Header';
import Routes from './Routes';
import Navbar from './components/Navbar';
import { useLocation } from 'react-router-dom';

const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #5d7a8c;
  background-image: url(${process.env.PUBLIC_URL}/img/background.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;

  .upper-band {
    width: 100%;
    flex: 0 0 177px;
    background-color: black;
    opacity: 0.34;
  }

  .divider {
    width: 100%;
    flex: 0 0 40px;
    opacity: 0.84;
    background: #7b95a6;
  }

  .lower-band {
    flex: 1 1 200px;
    opacity: 0.4;
    background-image: linear-gradient(180deg, #000000 0%, #eeeeee 100%);
  }

  .layer {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .canvas {
    position: relative;
    top: 60px;
    width: 100%;
    height: fit-content;
    min-height: 600px;
    max-width: 960px;
    background-color: #f2f2f2;
    margin-bottom: 60px;
  }
`;

const Layout = ({ children }) => {
  const containerRef = useRef();
  const { pathname } = useLocation();

  // set the height of the container to the scoll height for the document. This
  // helps the lower background element line up.
  useEffect(() => {
    const syncHeight = () => {
      const rect = document.querySelector('.canvas').getBoundingClientRect();

      const canvasHeight = rect.bottom + 60 + window.scrollY;
      if (canvasHeight > window.innerHeight) {
        containerRef.current.style.height = canvasHeight + 'px';
      } else {
        containerRef.current.style.height = window.innerHeight + 'px';
      }
    };

    // let the page render first, then adjsut the height of the background
    setTimeout(syncHeight, 50);
    window.syncHeight = syncHeight;

    window.addEventListener('resize', syncHeight);

    return () => {
      window.removeEventListener('resize', syncHeight);
    };
  }, [pathname]);

  return (
    <Container ref={containerRef}>
      <div className="upper-band" />
      <div className="divider" />
      <div className="lower-band" />

      <div className="layer">
        <div className="canvas">
          <Header />
          <Navbar />
          <Routes />
        </div>
      </div>
    </Container>
  );
};

export default Layout;
